import React, { useState, useEffect } from 'react'
import GMBAuthStatus from './GMBAuthStatus'
import { Card, CardContent } from '@/components/ui/card'
import { Loader2 } from 'lucide-react'
import { getStoredAccounts } from '@/utils/gmbWorkerApi'

interface GMBAuthGuardProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export default function GMBAuthGuard({ children, fallback }: GMBAuthGuardProps) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null)
  const [checking, setChecking] = useState(true)

  const checkAuth = async () => {
    try {
      const result = await getStoredAccounts()
      
      if (result.success) {
        setIsAuthenticated(result.data?.accounts && result.data.accounts.length > 0)
      } else {
        setIsAuthenticated(false)
      }
    } catch (error) {
      console.error('GMB auth check failed:', error)
      setIsAuthenticated(false)
    } finally {
      setChecking(false)
    }
  }

  useEffect(() => {
    checkAuth()
  }, [])

  const handleAuthSuccess = () => {
    setIsAuthenticated(true)
  }

  if (checking) {
    return (
      <Card>
        <CardContent className="flex items-center justify-center py-12">
          <div className="flex items-center gap-2">
            <Loader2 className="h-5 w-5 animate-spin" />
            <span>Checking GMB authentication...</span>
          </div>
        </CardContent>
      </Card>
    )
  }

  if (!isAuthenticated) {
    return fallback || <GMBAuthStatus onAuthSuccess={handleAuthSuccess} />
  }

  return <>{children}</>
}